// CollectPaymentModuleContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import {PAGE_STATE } from "./constants";
import {
  alertPopUpInitiator,
  topStripInitiator,
} from "../alertMessages/constants";
import { initialForm } from "../selectPaymentMode/components/constant";
import { ExamChargesModuleContext } from "../../examCharges/context";
import { validatePaymentMode } from "../selectPaymentMode/components/constant";
import { validateSequencing , reviewReceipt} from "../utils";

import {
  useChargesUpdater,
  useChargesFilter,
  useAutoSelectCharges,
  useFailedChequeCheck,
  useFetchPosFlag,
} from "./customHook";
import { isCentralizedAdmissionCase } from "../../studentCharges/studentChargesDetails/common";
import { useHistory } from "react-router";
import { getUrlSearchParams } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { RectifyRefundPaymentModeContext } from "../../../../../../modules/studentRefund/studentRefundRequest/rectificationRefund/selectPaymentMode/context";
import useValidateStdOutView from "../../../../../../hooks/useValidateStdOutView";

export const CollectPaymentModuleContext = createContext({
  currentPageState: "SELECT_CHARGES",
  loading: false,
  setLoading: () => {},
  chargesList: [],
});

export const moduleContextMapping = {
  'ExamCharges' : ExamChargesModuleContext,
  'Collections' : CollectPaymentModuleContext,
  "RectificationRefund" : RectifyRefundPaymentModeContext
}

export const useGetCollectPaymentContext = (module = 'Collections') => {
  return useContext(moduleContextMapping[module]);
};

export const CollectPaymentModuleProvider = ({ children, ...props }) => {

  const history = useHistory();
  const {source} = getUrlSearchParams(history?.location?.search);

  const [isChargesListFetching, setChargesListFetching] = useState(false);
  const [currentPageState, setCurrentPageState] = useState(
    PAGE_STATE.SELECT_CHARGES
  );
  const [currentStep, setCurrentStep] = useState(0);
  const [currentPaymentMode, setCurrentPaymentMode] = useState("default");
  const [bankDropdown, setBankDropdown] = useState([]);
  const [paymentModeForm, setPaymentModeForm] = useState(initialForm);
  const [studentBasicDetails, setStudentBasicDetails] = useState({});
  const [applicationId, setApplicationId] = useState("");
  const [selectedFilter, setFilterHandler] = useState("all");
  const [studentChargesList, setStudentCharges] = useState({
    REGULAR_CHARGES: "",
    OTHER_CHARGES: "",
  });
  const [studentChargesListFiltered, setStudentChargesListFiltered] = useState(
    []
  );
  const [selectedIndexMapCharges, setSelectedIndexMapCharges] = useState({
    REGULAR_CHARGES: {},
    OTHER_CHARGES: {},
  });
  const [selectedChargesAmount, setSelectedChargesAmount] = useState(0);
  const [partialAddAmount, setPartialPaymentAmount] = useState(0);
  const [selectedCharges, setSelectedCharges] = useState({});
  const [availablePosList, setAvailablePos] = useState([])
  const isOnlineModeEnabled = useFetchPosFlag(studentBasicDetails, setAvailablePos);
  const [alertPopup, setAlertPopup] = useState(alertPopUpInitiator);
  const [topStrip, setTopStrip] = useState(topStripInitiator);
  const [disableItemSelection, setDisableItemSelection] = useState({
    isAutoSelect: false,
  });
  const [freezeAllCheckboxes, setFreezeAllCheckboxes] = useState(false);
  const [freezeRegularChargesCheckboxes, setFreezeRegularChargesCheckboxes] =
    useState(false);

  const [roleId, setRoleId] = useState([]);
  const [bankMasterId, setBankMasterId] = useState({});
  const [balanceAmount, setBalanceAmount] = useState();
  const [balanceMode, setBalanceMode] = useState(false);
  const [loader, setloader] = useState(false);
  const [collectPayment, setCollectPayment] = useState([]);
  const [collectVoucherList, setCollectVoucherList] = useState([]);
  const [paymentModeIdLimitList, setPaymentModeIdLimitList] = useState({
    paymentModeIdList: [],
    maxLimit: "",
  });
  const [modifyPaymentModeData, setModifyPaymentModeData] = useState({});
  const [vouchersDialogOpen , setVouchersDialogOpen] = useState(true && selectedCharges);
  const [ totalUnpaidAmount, setTotalUnpaidAmount] = useState(0)
  const [state, setState] = useState('')

  useEffect(() => {
    const amountAlreadyPaid=collectPayment.reduce((amount,item)=>(amount+item.paidAmount),0)
    const total=(Number(partialAddAmount) || Number(selectedChargesAmount))-Number(amountAlreadyPaid)
    setBalanceAmount(total)
  }, [partialAddAmount, selectedChargesAmount]);

  console.log('studentBasicDetails', studentBasicDetails);

  // Custom hooks for organizing useEffect logic
  useChargesUpdater(
    selectedIndexMapCharges,
    setSelectedChargesAmount,
    setSelectedCharges,
    studentChargesListFiltered,
    studentBasicDetails,
    setPartialPaymentAmount,
  );
  useChargesFilter(
    selectedFilter,
    studentChargesList,
    setStudentChargesListFiltered
  );
  useAutoSelectCharges(
    studentBasicDetails,
    studentChargesList,
    setSelectedIndexMapCharges,
    setAlertPopup,
    setDisableItemSelection,
    setCollectPayment,
  );
  useFailedChequeCheck(studentChargesListFiltered, studentBasicDetails, setTopStrip);

  const paymentModeFormHandler = (key, value) => {
    setPaymentModeForm({ ...paymentModeForm, [key]: value });
  };

  const amountToBePaid = partialAddAmount || selectedChargesAmount;
  const totalCollectedAmount =  [...collectPayment, ...collectVoucherList]?.reduce((acc, curr) => acc + (+curr.paidAmount), 0);
   
  const forCentralizedAdmission = (source === 'centralized-adm' && isCentralizedAdmissionCase(studentBasicDetails?.opportunityOwnerId));


   const {checkingStdOutValidity}  = useValidateStdOutView({
    bu : studentBasicDetails?.bu,
    psid : studentBasicDetails?.psid,
    applicationId : studentBasicDetails?.applicationId
  })

  return (
    <CollectPaymentModuleContext.Provider
      value={{
        setApplicationId,
        studentBasicDetails,
        setStudentBasicDetails,
        currentStep,
        setCurrentStep,
        currentPageState,
        setCurrentPageState,
        selectedFilter,
        setFilterHandler,
        isChargesListFetching,
        setChargesListFetching,
        studentChargesList,
        studentChargesListFiltered,
        setStudentCharges,
        selectedCharges,
        partialAddAmount,
        setPartialPaymentAmount,
        setSelectedChargesAmount,
        selectedChargesAmount,
        setSelectedCharges,
        selectedIndexMapCharges,
        setSelectedIndexMapCharges,
        alertPopup,
        setAlertPopup,
        topStrip,
        setTopStrip,
        currentPaymentMode,
        setCurrentPaymentMode,
        bankDropdown,
        setBankDropdown,
        setPaymentModeForm,
        paymentModeForm,
        paymentModeFormHandler,
        disableItemSelection,
        setDisableItemSelection,
        roleId,
        setRoleId,
        bankMasterId,
        setBankMasterId,
        balanceAmount,
        setBalanceAmount,
        balanceMode,
        setBalanceMode,
        loader : (loader || checkingStdOutValidity),
        setloader,
        collectPayment,
        setCollectPayment,
        collectVoucherList,
        setCollectVoucherList,
        paymentModeIdLimitList,
        setPaymentModeIdLimitList,
        freezeAllCheckboxes,
        setFreezeAllCheckboxes,
        modifyPaymentModeData,
        setModifyPaymentModeData,
        freezeRegularChargesCheckboxes,
        setFreezeRegularChargesCheckboxes,
        isOnlineModeEnabled,
        amountToBePaid,
        totalCollectedAmount,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        totalUnpaidAmount,
        setTotalUnpaidAmount,
        availablePosList,
        state,
        setState,
        forCentralizedAdmission,

        //validation functions moved to context to make the components reusable for "Exam Charges"
        validatePaymentMode,
        validateSequencing,
        reviewReceipt,

        ...props,
      }}
    >
      {children}
    </CollectPaymentModuleContext.Provider>
  );
};
